import * as React from "react";
import { arrayMove } from "@dnd-kit/sortable";

export function useSortableTable({
  data = [],
  isDraggable = false,
  onReorder,
}) {
  const [rows, setRows] = React.useState(data);

  // sync with parent
  React.useEffect(() => {
    setRows(data || []);
  }, [data]);

  const handleDragEnd = React.useCallback(
    (event) => {
      if (!isDraggable) return;

      const { active, over } = event;

      if (!over || active.id === over.id) return;

      const oldIndex = rows.findIndex((r) => r.id === active.id);
      const newIndex = rows.findIndex((r) => r.id === over.id);

      const newRows = arrayMove(rows, oldIndex, newIndex);

      setRows(newRows);

      // notify parent
      onReorder?.(newRows);
    },
    [rows, isDraggable, onReorder],
  );

  return {
    rows,
    setRows, // optional (if you need manual control)
    handleDragEnd,
  };
}
